import { STORAGE_KEY } from "@constants";
import { MarketingData } from "@types";
import logger from "@utils/logger";
import { storage } from "kz-ui-sdk";

const MKTG_VERSION = "1.0.0";

/** This document's entry URL. The collector re-runs on later URLs, and the stored blob outlives the visit. */
const landingUrl = window.location.href;

export const getLandingUrl = () => landingUrl;

/** Mirrored in memory: iOS WebKit can drop localStorage mid-session. The sdk helper is unguarded. */
let mirror: Partial<MarketingData> | null = null;

export const getMarketingData = (): Partial<MarketingData> | null => {
  // Mirror first: it is never staler than the store, and a thrown write leaves the store stale
  if (mirror) return mirror;
  try {
    return storage.local.getItem(STORAGE_KEY.MARKETING_DATA) as Partial<MarketingData> | null;
  } catch (error) {
    logger._console.error(error);
    return null;
  }
};

export const setMarketingData = (data: Partial<MarketingData>): void => {
  mirror = data;
  try {
    storage.local.setItem(STORAGE_KEY.MARKETING_DATA, data, MKTG_VERSION);
  } catch (error) {
    logger._console.error(error);
  }
};

export const invalidateMarketingData = (): void => {
  try {
    storage.local.invalidate(STORAGE_KEY.MARKETING_DATA, MKTG_VERSION);
  } catch (error) {
    logger._console.error(error);
  }
};
